'use client'

import { CreateFeedbackForm } from '@common/modules/mailing/forms'

import type { ShareFeedbackPhase } from './ShareFeedback.types'
import { ShareFeedbackSending } from './ShareFeedbackSending'
import { ShareFeedbackSuccess } from './ShareFeedbackSuccess'

import styles from './ShareFeedback.module.scss'

type Props = {
  phase: ShareFeedbackPhase
  onSubmittingChange: (submitting: boolean) => void
  onSuccess: () => void
  hideTitle?: boolean
  selectContentClassName?: string
}

export function ShareFeedbackContent({
  phase,
  onSubmittingChange,
  onSuccess,
  hideTitle = false,
  selectContentClassName,
}: Props) {
  if (phase === 'success') {
    return <ShareFeedbackSuccess />
  }

  return (
    <div className={styles.formWrapper}>
      <CreateFeedbackForm
        onSubmittingChange={onSubmittingChange}
        onSuccess={onSuccess}
        hideTitle={hideTitle}
        selectContentClassName={selectContentClassName}
      />
      {phase === 'loading' && (
        <div className={styles.loadingOverlay}>
          <ShareFeedbackSending />
        </div>
      )}
    </div>
  )
}
